// "Como publicar" no celular (books/_home_steps): os 3 cards grudam abaixo do header ao rolar
// (position: sticky no CSS) e o próximo sobe por cima do anterior. Aqui só calculamos quanto
// cada card já foi coberto pelo seguinte (--cda-stack, de 0 a 1), para ele encolher e escurecer
// um pouco. Como depende só da posição da rolagem, ao subir a tela a animação se desfaz.
// Fica parado com "reduzir movimento" ligado.

function setupStack(section) {
  if (section.getAttribute('data-cda-steps-bound') === '1') return;
  section.setAttribute('data-cda-steps-bound', '1');

  var cards = Array.prototype.slice.call(section.querySelectorAll('.cda-steps__card'));
  if (cards.length < 2) return;

  var mobile = window.matchMedia('(max-width: 575.98px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var frame = null;

  function update() {
    frame = null;
    // saiu da página (navegação do Turbolinks): para de ouvir a rolagem
    if (!section.isConnected) {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      return;
    }
    var active = mobile.matches && !reducedMotion.matches;
    cards.forEach(function(card, index) {
      var next = cards[index + 1];
      var progress = 0;
      if (active && next) {
        var top = parseFloat(getComputedStyle(next).top) || 0;
        var distance = next.getBoundingClientRect().top - top;
        progress = Math.min(1, Math.max(0, 1 - distance / card.offsetHeight));
      }
      card.style.setProperty('--cda-stack', progress.toFixed(3));
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  update();
}

document.addEventListener('turbolinks:load', function() {
  Array.prototype.forEach.call(document.querySelectorAll('.cda-steps'), setupStack);
});
